var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name !== '')?_c('svg',{staticClass:"icon",attrs:{"height":_vm.height,"width":_vm.width,"fill":_vm.fill,"stroke":_vm.stroke}},[_c('use',{attrs:{"xlink:href":_vm.sprite + '#' + _vm.name,"href":_vm.sprite + '#' + _vm.name}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }